import { useEffect } from 'react';

import { useRedirect } from './use-redirect';

export function useRedirectEffect(redirectUrl, condition) {
  const redirect = useRedirect();

  useEffect(() => {
    if (condition) redirect(redirectUrl);
  }, [condition, redirect, redirectUrl]);
}
